import {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  MapContainer, MapContainerLoading, MapHeader,
} from './styles';
import { HistoryTooltip, TitleGraph } from '../styles';
import { InfoTooltip } from '../components/InfoTooltip';
import { MapContent } from './Content';
import { useHealthDataContext } from '../contexts/HealthDataContext';
import { useTranslation } from 'react-i18next';
import { useFilterContext } from '../contexts/FilterContext';

interface MapProps {
  hasHealth: boolean;
  loading: boolean;
}

export function GeoMap({
  hasHealth,
  loading,
}: Readonly<MapProps>): ReactElement {
  const { client } = useFilterContext();
  const { loading: loadingHealth } = useHealthDataContext();
  const [shouldShowLoading, setShouldShowLoading] = useState(true);
  const { t } = useTranslation();
  const prevClient = useRef<string>();

  useEffect(() => {
    if (!hasHealth) return;

    if (prevClient.current !== client) {
      prevClient.current = client;
      setShouldShowLoading(true);
      return;
    }

    if (!loadingHealth && shouldShowLoading) {
      setShouldShowLoading(false);
    }
  }, [client, hasHealth, loadingHealth]);

  if (loading || (shouldShowLoading && hasHealth)) {
    return (
      <MapContainerLoading>
        <div>
          <Skeleton
            height="22px"
            width="68px"
            borderRadius="100px"
            containerClassName="skeleton-container-span"
            className="skeleton-span"
          />
          <Skeleton
            height="24px"
            width="24px"
            borderRadius="8px"
            containerClassName="skeleton-container-span"
            className="skeleton-span"
          />
          <Skeleton
            borderRadius="100px"
            containerClassName="skeleton-container-span"
            className="skeleton-span"
          />
        </div>
        <Skeleton borderRadius="8px" className="skeleton-span" />
      </MapContainerLoading>
    );
  }

  return (
    <MapContainer>
      <MapHeader>
        <TitleGraph>{t('mapa')}</TitleGraph>
        <InfoTooltip
          id="map"
          disabled={!hasHealth}
        >
          <HistoryTooltip>
            <span>
              {t('numerosReferentesTotalEstado')}
            </span>
          </HistoryTooltip>
        </InfoTooltip>
        <span>
          {t('numerosReferentesTotalEstado')}
        </span>
      </MapHeader>
      <MapContent hasHealth={hasHealth} />
    </MapContainer>
  );
}
